import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {UserLoginState} from '../../../../shared/UserLoginState'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'

export class ProfileSectionLink extends HTMLAnchorElement {
    hasMadeAPICall: boolean
}

export class UIProfileLinkController {
    readonly overviewSection: HTMLDivElement
    readonly rankedSection: HTMLDivElement
    readonly historySection: HTMLDivElement
    readonly itemsSection: HTMLDivElement
    readonly friendsSection: HTMLDivElement
    readonly settingsSection: HTMLDivElement

    readonly overviewSectionLink: ProfileSectionLink
    readonly rankedSectionLink: ProfileSectionLink
    readonly historySectionLink: ProfileSectionLink
    readonly itemsSectionLink: ProfileSectionLink
    readonly friendsSectionLink: ProfileSectionLink
    readonly settingsSectionLink: ProfileSectionLink

    readonly sections: HTMLDivElement[]
    readonly sectionLinks: ProfileSectionLink[]
    activeLink: ProfileSectionLink

    constructor() {
        this.overviewSection = document.getElementById('overview-container') as HTMLDivElement
        this.rankedSection = document.getElementById('ranked-container') as HTMLDivElement
        this.historySection = document.getElementById('game-history-container') as HTMLDivElement
        this.itemsSection = document.getElementById('items-container') as HTMLDivElement
        this.friendsSection = document.getElementById('friends-container') as HTMLDivElement
        this.settingsSection = document.getElementById('settings-container') as HTMLDivElement

        this.overviewSectionLink = document.getElementById('tab-input-overview') as ProfileSectionLink
        this.rankedSectionLink = document.getElementById('tab-input-ranked') as ProfileSectionLink
        this.historySectionLink = document.getElementById('tab-input-game-history') as ProfileSectionLink
        this.itemsSectionLink = document.getElementById('tab-input-items') as ProfileSectionLink
        this.friendsSectionLink = document.getElementById('tab-input-friends') as ProfileSectionLink
        this.settingsSectionLink = document.getElementById('tab-input-settings') as ProfileSectionLink

        this.sections = [this.overviewSection, this.rankedSection, this.historySection, this.itemsSection, this.friendsSection, this.settingsSection]
        this.sectionLinks = [this.overviewSectionLink, this.rankedSectionLink, this.historySectionLink, this.itemsSectionLink, this.friendsSectionLink, this.settingsSectionLink]

        const defaultLink = this.overviewSectionLink
        this.activeLink = defaultLink
    }

    showSection(newSectionIdx: number): void {
        for(let index = 0; index < this.sections.length; index++) {
            const contentSection = this.sections[index]
            const tab = this.sectionLinks[index]

            if(index == newSectionIdx) {
                contentSection.classList.remove('hidden')
                tab.classList.add('active')
            } else {
                contentSection.classList.add('hidden')
                tab.classList.remove('active')
            }
        }
        this.activeLink = this.sectionLinks[newSectionIdx]
    }

    showSectionFromHash(): boolean {
        const hash = window.location.hash.replace('#', '')
        if(hash == '') return false

        for(let index = 0; index < this.sections.length; index++) {
            const section = this.sections[index]
            if(section.id.includes(hash) == true) {
                this.showSection(index)
                return true
            }
        }
        return false
    }

    static async genericApiCallWrapper<T extends BaseStoreItem[] | AjaxDataTypes.ProfileHistoryData | AjaxDataTypes.PublicProfileDataOverview | AjaxDataTypes.ProfileDataRankedSeasonDropdown[] | UserLoginState[]>(link: ProfileSectionLink, endpoint: string, callback: (input: T) => void) {
        if(link.hasMadeAPICall) return
        const response = await UIAjaxWrapper.getRequestHandler(endpoint, undefined)
        if(response == undefined) return
        if(!response.isSuccess) return
        const items = response.json as T
        callback(items)
        link.hasMadeAPICall = true
    }

    resetApiCalls() {
        this.sectionLinks.forEach((link) => {
            link.hasMadeAPICall = false
        })
    }
}
